import { get } from 'lodash'
import routes from '~/const/routes'

export const state = () => ({
  items: [],
  meta: {
    totalItems: null
  },
  requestParams: null
})

export const getters = {
  items: state => state.items,
  meta: state => state.meta,
  requestParams: state => state.requestParams
}

export const mutations = {
  RESET(state) {
    state.items = []
    state.meta = { totalItems: null }
    state.requestParams = null
  }
}

export const actions = {
  async getAll({ commit }, { config = {} }) {
    const { data, meta } = get(await this.$axios.get(routes.savedroute.list(), config), 'data')

    commit(
      'AFTER_GET_ALL',
      {
        namespace: 'savedroutes',
        items: data,
        meta,
        params: config.params
      },
      { root: true }
    )

    return { data, meta }
  },
  async create({ commit }, { payload = {}, config = {} }) {
    const data = get(await this.$axios.post(routes.savedroute.list(), payload, config), 'data')
    commit(
      'AFTER_CREATE',
      {
        namespace: 'savedroutes',
        item: data
      },
      { root: true }
    )
    return data
  },
  async read({ commit }, { id, config = {} }) {
    const data = get(await this.$axios.get(routes.savedroute.concrete(id), config), 'data')
    commit(
      'AFTER_READ',
      {
        namespace: 'savedroutes',
        item: data
      },
      { root: true }
    )
    return data
  },
  async update({ commit }, { id, payload = {}, config = {} }) {
    const data = get(await this.$axios.put(routes.savedroute.concrete(id), payload, config), 'data')
    commit(
      'AFTER_UPDATE',
      {
        namespace: 'savedroutes',
        item: data
      },
      { root: true }
    )
    return data
  },
  async delete({ commit }, { id, config = {} }) {
    const response = await this.$axios.delete(routes.savedroute.concrete(id), config)
    commit('AFTER_DELETE', { namespace: 'savedroutes', id }, { root: true })
    return response
  }
}
